<template>
  <v-card class="remittance" flat>
    <v-btn fixed right bottom icon x-large class="indigo" to="/admin/newRemit" style="z-index: 10">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>
    
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getRemits" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col>主播</v-col>
        <v-col>編號</v-col>
        <v-col>抽成</v-col>
        <v-col>銀行名稱</v-col>
        <v-col>銀行分行</v-col>
        <v-col>銀行帳號</v-col>
        <v-col>申請提款金額</v-col>
        <v-col>備註</v-col>
        <v-col>經手人</v-col>
        <v-col v-if="tab == 0">建立時間</v-col>
        <v-col v-if="tab == 1">審核時間</v-col>
        <v-col v-if="tab == 0" style="min-width: 100px; max-width: 100px"></v-col>
      </v-row>

      <div class="table-body">
        <template v-for="remit in remits">
          <v-row class="table-content" no-gutters :key="remit.id">
            <v-col>
              <v-avatar size="40" class="mr-2">
                <v-img :src="$HOST_URL + remit.seller.usericon"/>
              </v-avatar>
                {{ remit.seller.nickname }}
            </v-col>
            <v-col>
              {{ remit.seller.id | seller }}
            </v-col>
            <v-col>
              {{ remit.commision * 100 }}%
            </v-col>
            <v-col>
              {{ remit.bank }}
            </v-col>
            <v-col>
              {{ remit.bank_branch }}
            </v-col>
            <v-col>
              {{ remit.account_number }}
            </v-col>
            <v-col>
              {{ remit.amount }}
            </v-col>
            <v-col>
              {{ remit.remark }}
            </v-col>
            <v-col>
              {{ remit.handler }}
            </v-col>
            <v-col v-if="tab == 0">
              {{ remit.created_at | formatDate}}
            </v-col>
            <v-col v-if="tab == 1">
              {{ remit.updated_at | formatDate }}
            </v-col>
            <v-col v-if="tab == 0" style="min-width: 100px; max-width: 100px">
              <v-btn icon color="error" @click="$root.$emit('confirmDialog', () => reject(remit.id), `確定拒絕 <span class='pink--text'>${remit.seller.nickname}</span> 申請提款 <span class='pink--text'>${remit.amount}</span>？`, 'fa-times')">
                <v-icon>fa-times</v-icon>
              </v-btn>
              <v-btn icon color="success" @click="$root.$emit('confirmDialog', () => permit(remit.id), `確定批准 <span class='pink--text'>${remit.seller.nickname}</span> 申請提款 <span class='pink--text'>${remit.amount}</span>？`, 'fa-check')">
                <v-icon>fa-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import AdminToolbar from '@/components/admin/AdminToolbar'
export default {
  components: { AdminToolbar },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '建立日期', table: 'members', column: 'created_at' },
      ],
      sortTypes: [],
      sort: '',
      tabs: [
        {text: '待審核', value: 0},
        {text: '已批准', value: 1},
      ],
      tab: 0,
      search_condition: [],
      remits: []
    }
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.members = []
      this.getRemits()
    },
    getRemits() {
      this.busy = true
      this.axios(`/admin/account/remit`).then(response => {
        this.remits = response.data.filter(remit => this.tab == 0 ? !remit.remitted : remit.remitted)
      })
    },
    reject(id) {
      this.axios.delete(`/admin/account/remit/${id}`).then(response => {
        this.$root.$emit('alert', 'success', '拒絕成功')
        this.remits.splice(this.remits.findIndex(remit => remit.id == id), 1)
      }).catch(e => {
        this.$root.$emit('alert', 'error', '拒絕失敗')
      })
    },
    permit(id) {
      this.axios.put('/admin/account/do/remit', {
        acount_record_id: id
      }).then(response => {
        this.$root.$emit('alert', 'success', '提款成功')
        this.remits.splice(this.remits.findIndex(remit => remit.id == id), 1)
      }).catch(e => {
        if(e.response.data.message.includes('the wallet is not enough')) {
          this.$root.$emit('alert', 'error', '錢包餘額不足')
        }
        else {
          this.$root.$emit('alert', 'error', '提款失敗')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.remittance {

}
</style>